import { Component, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { OnCallBookingAllocComponent } from './on-call-booking-alloc/on-call-booking-alloc.component';
import { OnCallBookingApproveDialogComponent } from 'src/app/pages/operations/booking-layout/on-call-booking/on-call-booking-approve-dialog/on-call-booking-approve-dialog.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-on-call-booking',
  templateUrl: './on-call-booking.component.html',
  styleUrls: ['./on-call-booking.component.scss']
})
export class OnCallBookingComponent {

  showFlag: boolean = false;
  _mData: any = [];
  _mCurrentUserData: any;
  _mEmpId: number = null;
  _mCurrentUserVendorFlag: boolean = false;
  private readonly _mBaseColumns: string[] = [
    'site',
    'bookedBy',
    'employeeId',
    'employeeName',
    'tripUserPassword',
    'divertReason',
    'traveldate',
    'travelTime',
    'vendor',
    'escort',
    'status',
    'action'
  ];
  _mColumns: string[] = [...this._mBaseColumns];
  _mRawData: any[] = [];
  searchSubject$ = new Subject<string>();
  ELEMENT_DATA: any[] = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  clientCode: string;
  expandedRows = new Set<any>();
  fromDate: Date | null = new Date();
  toDate: Date | null = new Date();
  searchData = '';
  locationList: any[] = [];
  _mCardSitesData: any[] = [];
  mCardLocation = new FormControl([]);
  mCardSite = new FormControl([]);
  filterForm = new FormGroup({
    locations: this.mCardLocation,
    sites: this.mCardSite
  });
  cardLocationSettings = {
    itemsShowLimit: 1,
    idField: 'locationId',
    textField: 'locationName',
    allowSearchFilter: true,
    searchPlaceholderText: 'Search'
  };
  cardSiteSettings = {
    itemsShowLimit: 1,
    idField: 'siteId',
    textField: 'siteName',
    allowSearchFilter: true,
    searchPlaceholderText: 'Search'
  };
  deviceStatus: any = '';

  constructor(
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    public readonly serviceLocalStorage: ServiceLocalStorage,
    private ngxLoader: NgxUiLoaderService,
    public readonly dialog: MatDialog,
  ) {

  }

  ngOnInit(): void {
    this.searchSubject$.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(value => {
      if (!this.isOnCallActionAllowed) {
        return;
      }
      const key = (value || '').toString().trim();
      this.searchData = key;
      if (key.length === 0 || key.length >= 3) {
        this.getAll(this._mCurrentUserData.id);
      }
    });
    this.getCurrentUser();
  }

  getCurrentUser() {
    this._mCurrentUserData = this.serviceLocalStorage.getUserObject();
    if (!this._mCurrentUserData) return;
    const { role, id } = this._mCurrentUserData.userInfoDetails;
    this._mCurrentUserVendorFlag = role.name === 'Vendor';
    this._mEmpId = [1, 2, 4].includes(role.id) ? "" : id;
    this.clientCode = (this._mCurrentUserData?.clientCode || localStorage.getItem('clientCode') || '').toLowerCase();
    this.checkIsOnCallActionAllowed();
    // this.getAll(this._mCurrentUserData.id);
  }

  onFromDateChanged(): void {
    if (this.fromDate && this.toDate && this.startOfDay(this.toDate) < this.startOfDay(this.fromDate)) {
      this.toDate = this.fromDate;
    }
  }

  submitDateFilter(): void {
    if (this.isOnCallActionAllowed) {
      if (!this.cardLocationIds().length) {
        this.notifyService.showWarning('Please select location', null);
        return;
      }
      if (!this.cardSiteIds().length) {
        this.notifyService.showWarning('Please select site', null);
        return;
      }
      if (!this.fromDate) {
        this.notifyService.showWarning('Please select From date', null);
        return;
      }
      if (!this.toDate) {
        this.notifyService.showWarning('Please select To date', null);
        return;
      }
      if (this.startOfDay(this.toDate) < this.startOfDay(this.fromDate)) {
        this.notifyService.showWarning('To date should be greater than or equal to From date', null);
        return;
      }
    }
    this.getAll(this._mCurrentUserData.id);
  }

  resetDateFilter(): void {
    this.fromDate = null;
    this.toDate = null;
    this.searchData = '';
    this.mCardLocation.setValue([]);
    this.mCardSite.setValue([]);
    this._mCardSitesData = [];
    this.showFlag = false;
    this._mRawData = [];
    this._mData = [];
    this.ELEMENT_DATA = [];
    this.expandedRows.clear();
    this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  }

  private startOfDay(date: Date): number {
    const copy = new Date(date);
    copy.setHours(0, 0, 0, 0);
    return copy.getTime();
  }

  private formatFilterDate(date: Date): string {
    const month = date.getMonth() + 1;
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const monthText = month < 10 ? '0' + month : month;
    return date.getFullYear() + '-' + monthText + '-' + day;
  }

  getAll(userId) {
    if (this.isOnCallActionAllowed && (!this.fromDate || !this.toDate || !this.cardSiteIds().length)) {
      return;
    }
    this.ngxLoader.start();
    const url = this.isOnCallActionAllowed
      ? ApiConstants.getSpecialBookingForVendorV2
      + '?fromDate=' + this.formatFilterDate(this.fromDate)
      + '&toDate=' + this.formatFilterDate(this.toDate)
      + '&userid=' + userId
      + '&siteIds=' + this.cardSiteIds().join(',')
      + '&searchkey=' + encodeURIComponent(this.searchData || '')
      : ApiConstants.getSpecialBookingForVendor + userId;
    this.apiService.doGetRequestWithResponse(url,
      success => {
        this.ngxLoader.stop();
        if (success.status == 200) {
          this._mRawData = this.extractBookingList(success.body);
          this.showFlag = this._mRawData.length === 0;
          this._mData = this.setDataLocally(this._mRawData);
          this.ELEMENT_DATA = this._mData;
          this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.refreshDeviceTripStatuses();
        } else {
          this.showFlag = true;
          this._mRawData = [];
          this._mData = [];
          this.ELEMENT_DATA = [];
          this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      },
      error => {
        this.ngxLoader.stop();
        console.error(error);
      }
    );
  }

  setDataLocally(data: any[]) {
    return data.map(booking => {
      const passengers = this.mapTripPassengers(booking);
      const employeeIds = passengers.map(passenger => passenger.employeeId).filter(value => value && value !== '-');
      const employeeNames = passengers.map(passenger => passenger.name).filter(value => value && value !== '-');
      const passwords = passengers.map(passenger => passenger.password).filter(value => value && value !== '-');
      return {
        id: booking.id,
        site: booking.site.siteName,
        bookedby: booking.bookedBy.userInfoDetails.firstName,
        employeeId: employeeIds.length ? employeeIds.join(', ') : '-',
        firstName: employeeNames.length ? employeeNames.join(', ') : '-',
        tripUserPassword: passwords.length ? passwords.join(', ') : '-',
        divertReason: booking.divertReason || 'NA',
        vendorRejectReason: booking.vendorRejectReason || 'NA',
        reason: booking.reason || 'NA',
        passengers,
        travelDate: booking.travelDate,
        travelTime: booking.reportingTime,
        referenceNo: booking.referenceNumber || '-',
        requestNo: booking.requestNo || '-',
        proDisplayName: booking.proDisplayName || 'Not Available',
        pickUpFrom: booking.fromAddress || '-',
        dropTo: booking.toAddress || '-',
        vehicleType: booking.vehicleType?.vehicleType || 'Yet to Allocate',
        pickDrop: booking.pickDrop,
        vendor: booking.vendorMaster?.name || "Yet to Allocate",
        escort: booking.escortRequired ? "YES" : "No",
        vehicleNumber: booking.vehicle?.registrationNo || "Yet to Allocate",
        driver: booking.driver?.name || "Yet to Allocate",
        driverNumber: booking.driver?.contactNumber ?? booking.driver?.contactNo ?? "NA",
        status: booking.status,
        vendorAccepted: booking.vendorAccepted,
        tripId: this.resolveTripId(booking),
        deviceTripStatus: null,
        isTripStarted: this.resolveTripStarted(booking)
      };
    });
  }

  private collectTripUsers(booking: any): any[] {
    if (!booking) {
      return [];
    }
    if (Array.isArray(booking.tripUsers) && booking.tripUsers.length) {
      return booking.tripUsers;
    }
    const details = booking.tripDetails;
    if (Array.isArray(details)) {
      const nested = details.flatMap(item => Array.isArray(item?.tripUsers) ? item.tripUsers : []);
      if (nested.length) {
        return nested;
      }
      if (details.some(item => item?.tripUser || item?.tripUserPassword != null)) {
        return details;
      }
    } else if (details && Array.isArray(details.tripUsers) && details.tripUsers.length) {
      return details.tripUsers;
    }
    return [];
  }

  private mapTripPassengers(booking: any): { name: string; employeeId: string; password: string }[] {
    const users = this.collectTripUsers(booking);
    if (!users.length) {
      const info = booking?.bookedFor?.userInfoDetails;
      return [{
        name: info?.firstName || info?.displayName || '-',
        employeeId: info?.employeeId || '-',
        password: '-'
      }];
    }
    return users.map(entry => {
      const info = entry?.tripUser?.userInfoDetails || entry?.userInfoDetails || {};
      const password = entry?.tripUserPassword ?? entry?.password;
      return {
        name: info.firstName || info.displayName || '-',
        employeeId: info.employeeId || '-',
        password: password != null && String(password).trim() !== '' ? String(password) : '-'
      };
    });
  }

  private resolveTripId(booking: any): any {
    if (!booking) {
      return null;
    }
    const tripDetails = booking.tripDetails;
    if (tripDetails == null) {
      return booking.trip?.tripId ?? booking.tripId ?? null;
    }
    if (typeof tripDetails === 'number' || typeof tripDetails === 'string') {
      return tripDetails;
    }
    return tripDetails.tripId
      ?? tripDetails.id
      ?? booking.trip?.tripId
      ?? booking.tripId
      ?? null;
  }

  private resolveTripStarted(booking: any): boolean {
    if (!booking) {
      return false;
    }
    const status = (
      booking.deviceTripStatus
      || booking.trip?.deviceTripStatus
      || booking.tripDetails?.deviceTripStatus
      || booking.tripStatus
      || ''
    ).toString().trim().toLowerCase();
    // Prefer live device status when available (overrides stale tripStarted flags).
    if (status && status !== 'na') {
      return status !== 'not started'
        && status !== 'not_started'
        && status !== 'yet to start';
    }
    return booking.tripStarted === true || booking.isTripStarted === true;
  }

  private refreshDeviceTripStatuses(): void {
    if (!this.isOnCallActionAllowed || !Array.isArray(this.ELEMENT_DATA)) {
      return;
    }
    this.ELEMENT_DATA.forEach(element => {
      if (element?.tripId) {
        this.getDeviceTripStatus(element);
      }
    });
  }

  getDeviceTripStatus(element: any): void {
    // New on-call vendor flow only — never poll device status in legacy flow.
    if (!this.isOnCallActionAllowed || !element) {
      return;
    }
    const tripId = element.tripId
      ?? element.tripDetails?.tripId
      ?? element.tripDetails?.id
      ?? (typeof element.tripDetails === 'number' || typeof element.tripDetails === 'string'
        ? element.tripDetails
        : null);

    if (!tripId) {
      element.deviceTripStatus = 'NA';
      return;
    }

    this.apiService.doGetRequestWithResponse(
      ApiConstants.getDeviceTripStatus + '?tripId=' + tripId,
      success => {
        const status = success?.body?.deviceTripStatus || 'NA';
        this.deviceStatus = success?.body?.deviceTripStatus;
        element.deviceTripStatus = status;
        element.isTripStarted = this.resolveTripStarted({
          ...element,
          deviceTripStatus: status
        });
      },
      () => {
        element.deviceTripStatus = 'NA';
      }
    );
  }

  isPastTrip(element: any): boolean {
    if (!element?.travelDate) {
      return false;
    }
    const datePart = element.travelDate.toString().trim().split(/[\sT]/)[0];
    let day: Date | null = null;
    const dmy = datePart.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    const ymd = datePart.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
    if (dmy) {
      day = new Date(Number(dmy[3]), Number(dmy[2]) - 1, Number(dmy[1]));
    } else if (ymd) {
      day = new Date(Number(ymd[1]), Number(ymd[2]) - 1, Number(ymd[3]));
    } else {
      const parsed = new Date(datePart);
      day = isNaN(parsed.getTime()) ? null : parsed;
    }
    if (!day || isNaN(day.getTime())) {
      return false;
    }
    day.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (day.getTime() < today.getTime()) {
      return true;
    }
    if (day.getTime() > today.getTime()) {
      return false;
    }
    // Same day: past if reporting time has passed (old + new flow).
    const timeRaw = (element.travelTime ?? '').toString().trim();
    const match = timeRaw.match(/^(\d{1,2}):(\d{2})/);
    if (!match) {
      return false;
    }
    const bookingMinutes = Number(match[1]) * 60 + Number(match[2]);
    const now = new Date();
    return bookingMinutes <= now.getHours() * 60 + now.getMinutes();
  }

  /** New vendor flow only: past trip or device trip already started. */
  isNewFlowActionBlocked(element: any): boolean {
    if (!this.isOnCallActionAllowed) {
      return false;
    }
    if (this.isPastTrip(element)) {
      return true;
    }
    return this.resolveTripStarted(element);
  }

  /** True when live device trip status is running (vehicle breakdown replacement case). */
  isTripRunning(element: any): boolean {
    const status = (element?.deviceTripStatus || '').toString().trim().toLowerCase();
    return status === 'running';
  }

  cardStatusLabel(element: any): string {
    const deviceStatus = (element?.deviceTripStatus || '').toString().trim().toLowerCase();
    if (this.isOnCallActionAllowed && deviceStatus === 'stopped') {
      return 'Trip Completed';
    }
    return element?.status || '-';
  }

  /** New on-call vendor flow: Reset when trip is running so a replacement vehicle can be assigned. */
  canResetRunningTrip(element: any): boolean {
    if (!this.isOnCallActionAllowed || !this._mCurrentUserVendorFlag || !element) {
      return false;
    }
    const tripId = element.tripId
      ?? element.tripDetails?.tripId
      ?? element.tripDetails?.id
      ?? null;
    if (!tripId) {
      return false;
    }
    return this.isTripRunning(element);
  }

  resetRunningTrip(element: any): void {
    if (!this.canResetRunningTrip(element)) {
      return;
    }
    const bookingData = this._mRawData.find(data => data.id === element.id);
    if (!bookingData) {
      this.notifyService.showWarning('Booking not found', null);
      return;
    }
    if (!bookingData.vendorMaster?.id || !bookingData.vehicle?.id
      || !bookingData.vehicleType?.id || !bookingData.driver?.id) {
      this.notifyService.showWarning('Vehicle allocation not found for this booking', null);
      return;
    }
    // Open assignment dialog directly; API with RESET runs only when allocation changes.
    this.openReplacementVehicleDialog(element);
  }

  /** Apply special-booking action API body onto list row + raw booking. */
  private applyBookingActionResponse(element: any, bookingData: any, body: any): void {
    if (!body || !element) {
      return;
    }
    const status = body.status
      ?? body.bookingStatus
      ?? body.specialBooking?.status
      ?? body.data?.status;
    if (status != null && status !== '') {
      element.status = status;
      if (bookingData) {
        bookingData.status = status;
      }
    }

    const deviceTripStatus = body.deviceTripStatus
      ?? body.tripStatus
      ?? body.trip?.deviceTripStatus
      ?? body.specialBooking?.deviceTripStatus
      ?? body.data?.deviceTripStatus;
    if (deviceTripStatus != null && deviceTripStatus !== '') {
      element.deviceTripStatus = deviceTripStatus;
      element.isTripStarted = this.resolveTripStarted({
        ...element,
        deviceTripStatus
      });
    }

    const tripId = body.tripId
      ?? body.tripDetails?.tripId
      ?? body.trip?.tripId
      ?? body.data?.tripId;
    if (tripId != null && tripId !== '') {
      element.tripId = tripId;
    }

    const vehicle = body.vehicle ?? body.specialBooking?.vehicle ?? body.data?.vehicle;
    if (vehicle) {
      element.vehicleNumber = vehicle.registrationNo || element.vehicleNumber;
      if (bookingData) {
        bookingData.vehicle = vehicle;
      }
    }
    const driver = body.driver ?? body.specialBooking?.driver ?? body.data?.driver;
    if (driver) {
      element.driver = driver.name || element.driver;
      if (bookingData) {
        bookingData.driver = driver;
      }
    }
    const vehicleType = body.vehicleType ?? body.specialBooking?.vehicleType ?? body.data?.vehicleType;
    if (vehicleType && bookingData) {
      bookingData.vehicleType = vehicleType;
    }
    const vendor = body.vendorMaster ?? body.specialBooking?.vendorMaster ?? body.data?.vendorMaster;
    if (vendor) {
      element.vendor = vendor.name || element.vendor;
      if (bookingData) {
        bookingData.vendorMaster = vendor;
      }
    }
  }

  /** After trip reset (breakdown), open allocate/change vehicle dialog without started-trip block. */
  private openReplacementVehicleDialog(element: any): void {
    if (!this.isOnCallActionAllowed || !element) {
      return;
    }
    const bookingData = this._mRawData.find(data => data.id === element.id);
    if (!bookingData) {
      return;
    }
    this.dialog.open(OnCallBookingApproveDialogComponent, {
      disableClose: true,
      panelClass: 'on-call-booking-action-modal',
      width: '800px',
      data: {
        bookingData,
        isEditAction: true,
        isReplacementAfterReset: true,
        isAdminUser: false,
        isVendorUser: this._mCurrentUserVendorFlag,
        loggedInVendor: this._mCurrentUserData?.vendorMaster || bookingData.vendorMaster || null
      }
    }).afterClosed().subscribe(result => {
      // Only refresh when assignment actually changed (APPROVED); else keep RESET from API.
      if (result?.success && result?.assignmentChanged) {
        this.applyBookingActionResponse(element, bookingData, result.apiBody);
        this.getAll(this._mCurrentUserData.id);
      }
    });
  }

  restartTrip(element: any): void {
    if (!this.isOnCallActionAllowed || element?.status !== 'Approved') {
      return;
    }
    const tripId = element.tripId
      ?? element.tripDetails?.tripId
      ?? element.tripDetails?.id
      ?? null;
    if (!tripId) {
      this.notifyService.showWarning('Trip not found', null);
      return;
    }
    this.ngxLoader.start();
    this.apiService.doPostRequestWithResponse(
      ApiConstants.tripAction + tripId + '&action=RESTART',
      '',
      success => {
        this.ngxLoader.stop();
        if (success.status === 200) {
          const message = success?.body?.message || 'Error in updating';
          if (message === 'Updated successfully') {
            this.notifyService.showSuccess(message, null);
            this.getAll(this._mCurrentUserData.id);
          } else {
            this.notifyService.showWarning(message, null);
          }
        } else {
          this.notifyService.showWarning(success?.body?.message || 'Error in updating', null);
        }
      },
      error => {
        this.ngxLoader.stop();
        this.notifyService.showError(error?.error?.message || 'Error in updating', null);
      }
    );
  }

  pendingStatusRequest(element: any, status: any) {
    // Old-flow Edit/Allocate: past trip only.
    if (this.isPastTrip(element)) {
      return;
    }
    if (status === "EDIT") this.openDialog(element);
  }

  openDialog(element): void {
    if (!this._mCurrentUserVendorFlag || this.isPastTrip(element)) return;
    const userData = this._mRawData.find(data => data.id === element.id);
    this.dialog.open(OnCallBookingAllocComponent, {
      disableClose: true,
      height: '500px',
      width: '55%',
      data: {
        employeeAccessFlag: false,
        vendorAccessFlag: true,
        userData
      },
    }).afterClosed().subscribe(result => {
      if (result) {
        // Success/error toast is handled inside the allocation dialog (uses the API message).
        this.getAll(this._mCurrentUserData.id);
      }
    });
  }

  updateSpecialBooking(element) {
    const data = this._mRawData.find(data => data.id === element.id);
    data.status = element.status;
    data.bookedFor.userInfoDetails.userProject = null;
    data.bookedFor.userInfoDetails.userCategory = null;
    this.apiService.doPutRequestWithResponse(ApiConstants.updateSpecialBookingStatus,
      data,
      success => {
        if (success) {
          this.getAll(this._mCurrentUserData.id);
          this.notifyService.showSuccess("Updated successfully", null);
        }
      },
      error => {
        this.notifyService.showError(error, null);
      }
    );
  }

  onRejectStatusRequest(item) {
    if (this.isPastTrip(item)) {
      return;
    }
    const data = this._mRawData.find(booking => booking.id === item.id);
    Object.assign(data, {
      status: "REJECTED_BY_VENDOR",
      bookedFor: { ...data.bookedFor, userInfoDetails: { ...data.bookedFor.userInfoDetails, userProject: null, userCategory: null } },
      vehicleList: null,
      vehicle: null,
      driver: null
    });

    this.ngxLoader.start();
    this.apiService.doPutRequestWithResponse(ApiConstants.updateSpecialbooking, item, (success) => {
      this.ngxLoader.stop();
      if (success) {
        this.notifyService.showInfo("Updated successfully", null);
        this.getAll(this._mCurrentUserData.id);
      }
    }, (error) => {
      this.ngxLoader.stop();
      this.notifyService.showError(error, null);
    });
  }

  acceptTrip(element) {
    const blocked = this.isOnCallActionAllowed
      ? this.isNewFlowActionBlocked(element)
      : this.isPastTrip(element);
    if (blocked) {
      return;
    }

    // New flow: vendoraction with ACCEPTED
    if (this.isOnCallActionAllowed) {
      const bookingData = this._mRawData.find(data => data.id === element.id);
      if (!bookingData) return;
      const payload = {
        action: 'ACCEPTED',
        specialBookingId: bookingData.id
      };
      this.ngxLoader.start();
      this.apiService.doPostRequestWithResponse(ApiConstants.specialbookingActionByVendor, payload,
        success => {
          this.ngxLoader.stop();
          if (success.body?.success !== false) {
            this.notifyService.showSuccess(success.body?.message || 'Accepted successfully', null);
            this.getAll(this._mCurrentUserData.id);
          } else {
            this.notifyService.showWarning(success.body?.message || 'Accept failed', null);
          }
        },
        error => {
          this.ngxLoader.stop();
          this.notifyService.showError(error?.error?.message || error?.message || 'Accept failed', null);
        }
      );
      return;
    }

    // Old flow
    this.apiService.doGetRequestWithResponse(ApiConstants.onCallBookingAcceptedByVendorMaster + element.id, success => {
      if (success.status == 200) {
        this.getAll(this._mCurrentUserData.id);
        this.notifyService.showSuccess("Updated successfully", null);
      }
    },
      error => {
        this.notifyService.showError(error, null);
      }
    );
  }

  openApproveDialog(element, isEditAction: boolean = false): void {
    if (!this.isOnCallActionAllowed || this.isNewFlowActionBlocked(element)) {
      return;
    }
    const bookingData = this._mRawData.find(data => data.id === element.id);
    if (!bookingData) return;
    this.dialog.open(OnCallBookingApproveDialogComponent, {
      disableClose: true,
      panelClass: 'on-call-booking-action-modal',
      width: '800px',
      data: {
        bookingData,
        isEditAction: !!isEditAction || this.isApprovedStatus(element),
        isAdminUser: false,
        isVendorUser: this._mCurrentUserVendorFlag,
        loggedInVendor: this._mCurrentUserData?.vendorMaster || bookingData.vendorMaster || null
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.getAll(this._mCurrentUserData.id);
      }
    });
  }

  isApprovedStatus(element: any): boolean {
    const status = (element?.status || '').toString().toUpperCase();
    return status === 'APPROVED';
  }

  hasAction(element: any): boolean {
    if (!this._mCurrentUserVendorFlag || !element) {
      return false;
    }
    if (this.isOnCallActionAllowed) {
      if (this.canResetRunningTrip(element)) {
        return true;
      }
      if (this.isNewFlowActionBlocked(element)) {
        return false;
      }
      const status = (element.status || '').toString().toUpperCase();
      return status === 'SENT_FOR_VENDOR_APPROVAL'
        || status === 'ACCEPTED_BY_VENDOR'
        || this.isApprovedStatus(element);
    }
    if (this.isPastTrip(element)) {
      return false;
    }
    return element.status === 'Approved'
      || element.status === 'SENT_FOR_VENDOR_APPROVAL';
  }

  rejectOnCallBooking(element): void {
    if (!this.isOnCallActionAllowed || this.isNewFlowActionBlocked(element)) {
      return;
    }
    const bookingData = this._mRawData.find(data => data.id === element.id);
    if (!bookingData) return;

    Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger ms-2' },
      buttonsStyling: false
    }).fire({
      title: 'WARNING : Are you sure want to reject this booking ?',
      text: 'Rejected',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonColor: '#34c38f',
      cancelButtonColor: '#f46a6a'
    }).then(result => {
      if (!result.value) {
        return;
      }
      Swal.fire({
        html: `<label class="routing-reject-reason-label">Reason</label>
               <textarea id="routing-reject-reason-input" class="routing-reject-reason-input" rows="3" placeholder="Reason"></textarea>`,
        showCancelButton: true,
        confirmButtonText: 'Submit',
        cancelButtonText: 'Cancel',
        reverseButtons: true,
        buttonsStyling: false,
        focusConfirm: false,
        customClass: {
          popup: 'routing-reject-reason-popup',
          actions: 'routing-reject-reason-actions',
          confirmButton: 'routing-reject-reason-submit',
          cancelButton: 'routing-reject-reason-cancel'
        },
        preConfirm: () => {
          const input = document.getElementById('routing-reject-reason-input') as HTMLTextAreaElement;
          return (input?.value || '').trim();
        }
      }).then(reasonResult => {
        if (!reasonResult.isConfirmed) {
          return;
        }
        const reason = String(reasonResult.value || '').trim();
        const payload: any = {
          specialBookingId: bookingData.id,
          bookedFor: bookingData.bookedFor?.id,
          action: 'REJECTED',
          reason
        };
        if (this._mCurrentUserVendorFlag && bookingData.vendorMaster?.id) {
          payload.vendorId = Number(bookingData.vendorMaster.id);
        }
        this.ngxLoader.start();
        this.apiService.doPostRequestWithResponse(ApiConstants.specialbookingActionByVendor, payload,
          success => {
            this.ngxLoader.stop();
            if (success.body?.success) {
              this.notifyService.showSuccess(success.body?.message || 'Rejected successfully', null);
              this.getAll(this._mCurrentUserData.id);
            } else {
              this.notifyService.showWarning(success.body?.message || 'Reject failed', null);
            }
          },
          error => {
            this.ngxLoader.stop();
            this.notifyService.showError(error?.error?.message || error?.message || 'Reject failed', null);
          }
        );
      });
    });
  }
  isOnCallActionAllowed: boolean = false;
  checkIsOnCallActionAllowed() {
    this.apiService.doGetRequestWithResponse(ApiConstants.isOnCallActionAllowed + '?clientCode=' + this.clientCode, success => {
      if (success.status === 200) {
        this.isOnCallActionAllowed = !!success.body.isOnCallAction;
      } else if (success.status === 204) {
        this.isOnCallActionAllowed = false;
      } else {
        this.isOnCallActionAllowed = false;
      }
      this.updateDisplayedColumns();
      this.refreshDeviceTripStatuses();
      if (this.isOnCallActionAllowed) {
        this.loadLocations();
      } else {
        this.getAll(this._mCurrentUserData.id);
      }
    }, error => {
      this.isOnCallActionAllowed = false;
      this.updateDisplayedColumns();
      this.getAll(this._mCurrentUserData.id);
    })
  }

  loadLocations() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getAllLocationList, success => {
      this.locationList = success.status === 200 ? (success.body || []) : [];
      if (this.locationList.length) {
        this.mCardLocation.setValue([this.locationList[0]]);
        this.loadMultiSitesByLocations();
      }
    }, () => {
      this.locationList = [];
    });
  }

  onItemSelectloc() {
    setTimeout(() => this.loadMultiSitesByLocations());
  }

  OnItemDeSelectloc() {
    setTimeout(() => this.loadMultiSitesByLocations());
  }

  onSelectAllloc() {
    this.mCardLocation.setValue(this.locationList || []);
    this.loadMultiSitesByLocations();
  }

  onDeSelectAllloc() {
    this.mCardLocation.setValue([]);
    this._mCardSitesData = [];
    this.mCardSite.setValue([]);
  }

  loadMultiSitesByLocations() {
    const selectedLocations = Array.isArray(this.mCardLocation.value) ? this.mCardLocation.value : [];
    const previousSiteIds = new Set(this.cardSiteIds());
    if (!selectedLocations.length) {
      this._mCardSitesData = [];
      this.mCardSite.setValue([]);
      return;
    }
    const locationIds = selectedLocations
      .map(loc => loc?.locationId ?? loc?.id)
      .filter(id => id !== null && id !== undefined && id !== '')
      .join(',');
    if (!locationIds) {
      this._mCardSitesData = [];
      this.mCardSite.setValue([]);
      return;
    }
    this.ngxLoader.start();
    this.apiService.doGetRequestWithResponse(
      ApiConstants.getSiteUsingLocationId + locationIds,
      success => {
        this.ngxLoader.stop();
        this._mCardSitesData = success.status === 200 ? (success.body || []) : [];
        const kept = this._mCardSitesData.filter(site => previousSiteIds.has(String(site.siteId)));
        this.mCardSite.setValue(kept.length ? kept : (this._mCardSitesData[0] ? [this._mCardSitesData[0]] : []));
      },
      () => this.ngxLoader.stop()
    );
  }

  private cardLocationIds(): string[] {
    const value = this.mCardLocation?.value;
    if (!Array.isArray(value)) {
      return [];
    }
    return value
      .map(loc => loc?.locationId ?? loc?.id ?? loc)
      .filter(id => id !== null && id !== undefined && id !== '')
      .map(id => String(id));
  }

  private cardSiteIds(): string[] {
    const value = this.mCardSite?.value;
    if (!Array.isArray(value)) {
      return [];
    }
    return value
      .map(site => site?.siteId ?? site)
      .filter(id => id !== null && id !== undefined && id !== '')
      .map(id => String(id));
  }

  private extractBookingList(body: any): any[] {
    if (Array.isArray(body)) {
      return body;
    }
    if (Array.isArray(body?.dataList?.content)) {
      return body.dataList.content;
    }
    if (Array.isArray(body?.content)) {
      return body.content;
    }
    return [];
  }

  private updateDisplayedColumns(): void {
    this._mColumns = [...this._mBaseColumns];
  }

  isUnassigned(value: any): boolean {
    const text = (value ?? '').toString().trim().toLowerCase();
    return !text || text === '-' || text === 'yet to allocate' || text === 'na' || text === 'not available';
  }

  isRowExpanded(element: any): boolean {
    return !!element?.id && this.expandedRows.has(element.id);
  }

  toggleRow(element: any): void {
    if (!this.isOnCallActionAllowed || !element?.id) {
      return;
    }
    if (this.expandedRows.has(element.id)) {
      this.expandedRows.delete(element.id);
      return;
    }
    this.expandedRows.add(element.id);
    if (element?.tripId) {
      this.getDeviceTripStatus(element);
    }
  }

}
